'use strict';

// globalThis shim for EdgeHTML 18 / IE. Must run before any require() below
// that might touch code referencing `globalThis` at top level.
(function () {
  if (typeof globalThis === 'object') { return; }
  try {
    Object.defineProperty(Object.prototype, '__magic__', {
      get: function () { return this; },
      configurable: true
    });
    __magic__.globalThis = __magic__; // eslint-disable-line no-undef
    delete Object.prototype.__magic__;
  } catch (e) {
    var g = typeof self !== 'undefined' ? self
      : typeof window !== 'undefined' ? window
      : typeof global !== 'undefined' ? global : this;
    if (g) { g.globalThis = g; }
  }
})();

require('raf/polyfill');

// const Enzyme = require('enzyme');
// const Adapter = require('enzyme-adapter-react-16');
//
// Enzyme.configure({ adapter: new Adapter() });
if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  require('promise/lib/rejection-tracking').enable();
  window.Promise = require('promise/lib/es6-extensions.js');
}

// fetch() polyfill for making API calls.
require('whatwg-fetch');

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require('object-assign');

// IE11 doesn't support Array.includes
require('core-js/features/array/includes');
require('core-js/es/object/values');

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (process.env.NODE_ENV === 'test') {
  require('raf').polyfill(global);
}
//VO-10611 Web SSO: CAUI is not loaded in IE
require('string.prototype.startswith');
require('string.prototype.endswith');
require('string.prototype.includes');
// Do NOT `require("core-js/es/symbol")` here — it installs a broken
// Symbol.prototype.description getter on EdgeHTML 18 (legacy Edge WebView),
// which throws "Incompatible receiver, Symbol required" the first time
// any polyfill copies constructor properties. EdgeHTML has a good-enough
// native Symbol; only pull the specific iterator hook we need.
require("core-js/features/symbol/iterator.js");

// Polyfill for TextEncoder/TextDecoder in IE
if (typeof window.TextEncoder === 'undefined' || typeof window.TextDecoder === 'undefined') {
  const { TextEncoder, TextDecoder } = require('text-encoding');
  window.TextEncoder = TextEncoder;
  window.TextDecoder = TextDecoder;
}

const { initialize: dynamicImportPolyfill } = require('dynamic-import-polyfill');
dynamicImportPolyfill();